import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateLaundryEquipment, LaundryEquipment, LaundryEquipmentListResponse, LaundryEquipmentQueryParams } from '@frontend/laundry-app/types';

const endpoint = '/laundry-app-api/v1';
export class LaundryEquipmentClient extends APIClient {
    public static async fetchLaundryEquipments(
        accountId: string,
        queryParams?: ApiQueryParams<LaundryEquipmentQueryParams>
    ): Promise<LaundryEquipmentListResponse> {
        return await this.apiPaginated<LaundryEquipmentListResponse, LaundryEquipmentQueryParams>(`${endpoint}/accounts/${accountId}/equipments`, queryParams);
    }
    public static async postLaundryEquipment(accountId: string, body: CreateLaundryEquipment): Promise<LaundryEquipment> {
        const response = await this.post(`${endpoint}/accounts/${accountId}/equipments`, body);
        return await this.handleResponse<LaundryEquipment>(response);
    }
}
